/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invitesubexpiredmessage3Inputs */



/**
* | output |
* | --- |
* | "Your 'Monster' subscription expired. Invite 2 more friends for 7 extra days or go monthly." |
*
* @param {Invitesubexpiredmessage3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const invitesubexpiredmessage3 = /** @type {((inputs?: Invitesubexpiredmessage3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invitesubexpiredmessage3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Your 'Monster' subscription expired. Invite 2 more friends for 7 extra days or go monthly.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tu suscripción «Monster» ha caducado. Invita a 2 amigos más para conseguir 7 días extra o pásate al plan mensual.")
	return /** @type {LocalizedString} */ ("Подписка «Монстр» теперь отключена. Можешь позвать еще двух друзей и продлить ее на 7 дней или оплатить подписку на месяц.")
});
export { invitesubexpiredmessage3 as "inviteSubExpiredMessage" }